// Do not make edits in this file!
// This file is automatically generated and any changes will be overwritten.
// To fetch new design tokens check the design-system/README.md
/**
 * 0.625rem
 */
export const fontSize20 = '0.625rem';
/**
 * 0.6875rem
 */
export const fontSize25 = '0.6875rem';
/**
 * 0.75rem
 */
export const fontSize50 = '0.75rem';
/**
 * 0.875rem
 */
export const fontSize75 = '0.875rem';
/**
 * 1rem
 */
export const fontSize100 = '1rem';
/**
 * 1.125rem
 */
export const fontSize200 = '1.125rem';
/**
 * 1.25rem
 */
export const fontSize300 = '1.25rem';
/**
 * 1.375rem
 */
export const fontSize400 = '1.375rem';
/**
 * 1.5rem
 */
export const fontSize500 = '1.5rem';
/**
 * 1.75rem
 */
export const fontSize600 = '1.75rem';
/**
 * 2rem
 */
export const fontSize700 = '2rem';
/**
 * 2.25rem
 */
export const fontSize800 = '2.25rem';
/**
 * 2.5rem
 */
export const fontSize900 = '2.5rem';
/**
 * 3rem
 */
export const fontSize1000 = '3rem';
/**
 * 3.25rem
 */
export const fontSize1100 = '3.25rem';
/**
 * 3.5rem
 */
export const fontSize1200 = '3.5rem';
/**
 * 4rem
 */
export const fontSize1300 = '4rem';
/**
 * 4.5rem
 */
export const fontSize1400 = '4.5rem';
/**
 * 5rem
 */
export const fontSize1500 = '5rem';
/**
 * 6rem
 */
export const fontSize1600 = '6rem';
/**
 * 700
 */
export const fontWeightBold = 700;
/**
 * 400
 */
export const fontWeightRegular = 400;
/**
 * 1px
 */
export const thicknessThin = '1px';
/**
 * 2px
 */
export const thicknessThick = '2px';
/**
 * 0px
 */
export const radiusNone = '0px';
/**
 * 2px
 */
export const radiusXs = '2px';
/**
 * 4px
 */
export const radiusS = '4px';
/**
 * 8px
 */
export const radiusM = '8px';
/**
 * 12px
 */
export const radiusL = '12px';
/**
 * 20px
 */
export const radiusXl = '20px';
/**
 * 64px
 */
export const radiusCap = '64px';
/**
 * 0.25rem
 */
export const space25 = '0.25rem';
/**
 * 0.5rem
 */
export const space50 = '0.5rem';
/**
 * 0.75rem
 */
export const space75 = '0.75rem';
/**
 * 1rem
 */
export const space100 = '1rem';
/**
 * 1.25rem
 */
export const space125 = '1.25rem';
/**
 * 1.5rem
 */
export const space150 = '1.5rem';
/**
 * 2rem
 */
export const space200 = '2rem';
/**
 * 2.5rem
 */
export const space250 = '2.5rem';
/**
 * 3rem
 */
export const space300 = '3rem';
/**
 * 4rem
 */
export const space400 = '4rem';
/**
 * 5.5rem
 */
export const space550 = '5.5rem';
/**
 * 7.5rem
 */
export const space750 = '7.5rem';
/**
 * 10rem
 */
export const space1000 = '10rem';
/**
 * 13.5rem
 */
export const space1350 = '13.5rem';
/**
 * 0px 4px 16px rgba(0, 0, 0, 0.1)
 */
export const shadowSizeDefault = '0px 4px 16px rgba(0, 0, 0, 0.1)';
/**
 * 800ms
 */
export const durationSlowXlScreen = '800ms';
/**
 * 400ms
 */
export const durationSlowMobileNative = '400ms';
/**
 * 250ms
 */
export const durationSlowWeb = '250ms';
/**
 * 600ms
 */
export const durationStandardXlScreen = '600ms';
/**
 * 300ms
 */
export const durationStandardMobileNative = '300ms';
/**
 * 200ms
 */
export const durationStandardWeb = '200ms';
/**
 * 300ms
 */
export const durationQuickXlScreen = '300ms';
/**
 * 150ms
 */
export const durationQuickMobileNative = '150ms';
/**
 * 100ms
 */
export const durationQuickWeb = '100ms';
/**
 * 0
 */
export const durationInstantXlScreen = 0;
/**
 * 0
 */
export const durationInstantMobileNative = 0;
/**
 * 0
 */
export const durationInstantWeb = 0;
/**
 * cubic-bezier(0,0,1,1)
 */
export const easeLinear = 'cubic-bezier(0,0,1,1)';
/**
 * cubic-bezier(0.45, 1.45, 0.65, 1.0)
 */
export const easeBob = 'cubic-bezier(0.45, 1.45, 0.65, 1.0)';
/**
 * cubic-bezier(0.9, 0.0, 1.0, 1.0)
 */
export const easeExit = 'cubic-bezier(0.9, 0.0, 1.0, 1.0)';
/**
 * cubic-bezier(0.0, 0.0, 0.1, 1.0)
 */
export const easeEnter = 'cubic-bezier(0.0, 0.0, 0.1, 1.0)';
/**
 * cubic-bezier(0.8, 0.0, 0.0, 1.0)
 */
export const easeExpressive = 'cubic-bezier(0.8, 0.0, 0.0, 1.0)';
/**
 * cubic-bezier(0.4, 0.0, 0.4, 1.0)
 */
export const easeEasy = 'cubic-bezier(0.4, 0.0, 0.4, 1.0)';
/**
 * 150ms
 */
export const delayEmphasised = '150ms';
/**
 * 100ms
 */
export const delayStandard = '100ms';
/**
 * 33ms
 */
export const delayTight = '33ms';
/**
 * 75em
 */
export const breakpointXl = '75em';
/**
 * 56.25em
 */
export const breakpointL = '56.25em';
/**
 * 37.5em
 */
export const breakpointM = '37.5em';
/**
 * 1.400
 */
export const lineHeight20Short = '1.400';
/**
 * 1.400
 */
export const lineHeight20Long = '1.400';
/**
 * 1.450
 */
export const lineHeight25Short = '1.450';
/**
 * 1.450
 */
export const lineHeight25Long = '1.450';
/**
 * 1.500
 */
export const lineHeight50Short = '1.500';
/**
 * 1.500
 */
export const lineHeight50Long = '1.500';
/**
 * 1.571
 */
export const lineHeight75Short = '1.571';
/**
 * 1.571
 */
export const lineHeight75Long = '1.571';
/**
 * 1.500
 */
export const lineHeight100Short = '1.500';
/**
 * 1.625
 */
export const lineHeight100Long = '1.625';
/**
 * 1.444
 */
export const lineHeight200Short = '1.444';
/**
 * 1.555
 */
export const lineHeight200Long = '1.555';
/**
 * 1.400
 */
export const lineHeight300Short = '1.400';
/**
 * 1.600
 */
export const lineHeight300Long = '1.600';
/**
 * 1.364
 */
export const lineHeight400Short = '1.364';
/**
 * 1.545
 */
export const lineHeight400Long = '1.545';
/**
 * 1.450
 */
export const lineHeight500Short = '1.450';
/**
 * 1.670
 */
export const lineHeight500Long = '1.670';
/**
 * 1.357
 */
export const lineHeight600Short = '1.357';
/**
 * 1.570
 */
export const lineHeight600Long = '1.570';
/**
 * 1.375
 */
export const lineHeight700Short = '1.375';
/**
 * 1.500
 */
export const lineHeight700Long = '1.500';
/**
 * 1.333
 */
export const lineHeight800Short = '1.333';
/**
 * 1.500
 */
export const lineHeight800Long = '1.500';
/**
 * 1.300
 */
export const lineHeight900Short = '1.300';
/**
 * 1.500
 */
export const lineHeight900Long = '1.500';
/**
 * 1.300
 */
export const lineHeight1000Short = '1.300';
/**
 * 1.460
 */
export const lineHeight1000Long = '1.460';
/**
 * 1.320
 */
export const lineHeight1100Short = '1.320';
/**
 * 1.520
 */
export const lineHeight1100Long = '1.520';
/**
 * 1.357
 */
export const lineHeight1200Short = '1.357';
/**
 * 1.500
 */
export const lineHeight1200Long = '1.500';
/**
 * 1.300
 */
export const lineHeight1300Short = '1.300';
/**
 * 1.500
 */
export const lineHeight1300Long = '1.500';
/**
 * 1.280
 */
export const lineHeight1400Short = '1.280';
/**
 * 1.500
 */
export const lineHeight1400Long = '1.500';
/**
 * 1.300
 */
export const lineHeight1500Short = '1.300';
/**
 * 1.500
 */
export const lineHeight1500Long = '1.500';
/**
 * 1.290
 */
export const lineHeight1600Short = '1.290';
/**
 * 1.500
 */
export const lineHeight1600Long = '1.500';
/**
 * 0em
 */
export const letterSpacing20 = '0em';
/**
 * 0em
 */
export const letterSpacing25 = '0em';
/**
 * 0em
 */
export const letterSpacing50 = '0em';
/**
 * 0em
 */
export const letterSpacing75 = '0em';
/**
 * 0em
 */
export const letterSpacing100 = '0em';
/**
 * 0em
 */
export const letterSpacing200 = '0em';
/**
 * 0em
 */
export const letterSpacing300 = '0em';
/**
 * -0.0039em
 */
export const letterSpacing400 = '-0.0039em';
/**
 * -0.0042em
 */
export const letterSpacing500 = '-0.0042em';
/**
 * -0.0049em
 */
export const letterSpacing600 = '-0.0049em';
/**
 * -0.0056em
 */
export const letterSpacing700 = '-0.0056em';
/**
 * -0.0063em
 */
export const letterSpacing800 = '-0.0063em';
/**
 * -0.007em
 */
export const letterSpacing900 = '-0.007em';
/**
 * -0.0084em
 */
export const letterSpacing1000 = '-0.0084em';
/**
 * -0.0091em
 */
export const letterSpacing1100 = '-0.0091em';
/**
 * -0.0098em
 */
export const letterSpacing1200 = '-0.0098em';
/**
 * -0.011em
 */
export const letterSpacing1300 = '-0.011em';
/**
 * -0.0124em
 */
export const letterSpacing1400 = '-0.0124em';
/**
 * -0.014em
 */
export const letterSpacing1500 = '-0.014em';
/**
 * -0.0168em
 */
export const letterSpacing1600 = '-0.0168em';
export default {
    fontSize20,
    fontSize25,
    fontSize50,
    fontSize75,
    fontSize100,
    fontSize200,
    fontSize300,
    fontSize400,
    fontSize500,
    fontSize600,
    fontSize700,
    fontSize800,
    fontSize900,
    fontSize1000,
    fontSize1100,
    fontSize1200,
    fontSize1300,
    fontSize1400,
    fontSize1500,
    fontSize1600,
    fontWeightBold,
    fontWeightRegular,
    thicknessThin,
    thicknessThick,
    radiusNone,
    radiusXs,
    radiusS,
    radiusM,
    radiusL,
    radiusXl,
    radiusCap,
    space25,
    space50,
    space75,
    space100,
    space125,
    space150,
    space200,
    space250,
    space300,
    space400,
    space550,
    space750,
    space1000,
    space1350,
    shadowSizeDefault,
    durationSlowXlScreen,
    durationSlowMobileNative,
    durationSlowWeb,
    durationStandardXlScreen,
    durationStandardMobileNative,
    durationStandardWeb,
    durationQuickXlScreen,
    durationQuickMobileNative,
    durationQuickWeb,
    durationInstantXlScreen,
    durationInstantMobileNative,
    durationInstantWeb,
    easeLinear,
    easeBob,
    easeExit,
    easeEnter,
    easeExpressive,
    easeEasy,
    delayEmphasised,
    delayStandard,
    delayTight,
    breakpointXl,
    breakpointL,
    breakpointM,
    lineHeight20Short,
    lineHeight20Long,
    lineHeight25Short,
    lineHeight25Long,
    lineHeight50Short,
    lineHeight50Long,
    lineHeight75Short,
    lineHeight75Long,
    lineHeight100Short,
    lineHeight100Long,
    lineHeight200Short,
    lineHeight200Long,
    lineHeight300Short,
    lineHeight300Long,
    lineHeight400Short,
    lineHeight400Long,
    lineHeight500Short,
    lineHeight500Long,
    lineHeight600Short,
    lineHeight600Long,
    lineHeight700Short,
    lineHeight700Long,
    lineHeight800Short,
    lineHeight800Long,
    lineHeight900Short,
    lineHeight900Long,
    lineHeight1000Short,
    lineHeight1000Long,
    lineHeight1100Short,
    lineHeight1100Long,
    lineHeight1200Short,
    lineHeight1200Long,
    lineHeight1300Short,
    lineHeight1300Long,
    lineHeight1400Short,
    lineHeight1400Long,
    lineHeight1500Short,
    lineHeight1500Long,
    lineHeight1600Short,
    lineHeight1600Long,
    letterSpacing20,
    letterSpacing25,
    letterSpacing50,
    letterSpacing75,
    letterSpacing100,
    letterSpacing200,
    letterSpacing300,
    letterSpacing400,
    letterSpacing500,
    letterSpacing600,
    letterSpacing700,
    letterSpacing800,
    letterSpacing900,
    letterSpacing1000,
    letterSpacing1100,
    letterSpacing1200,
    letterSpacing1300,
    letterSpacing1400,
    letterSpacing1500,
    letterSpacing1600,
};
